export default __webpack_public_path__ + "static/media/linkedinAzul.593f97d2.svg";